import React from 'react';
import FormError from '../FormError';



export default function SelectForm({
    arrayElement ,
    label , 
    name , 
    value = false , 
    onChange , 
    classi , 
    errors,
    defaultValue,
    visualizza = false
}) {
    //console.log(arrayElement , ' arrayElement');
    const segnalaErrore = errors[name] ? 'is-invalid' : ''
    return(
        <div className={"m-3 "+classi}>
            <label htmlFor={name} className="form-label fw-bold"> {label} </label>
            <select 
                name={name} 
                className={"form-control " + segnalaErrore +' '+(!!visualizza ? ' bg-white border-0 p-0' : '')} 
                aria-label="Default select example"
                value={value}
                onChange={(event) => onChange(name, event.target.value)}
                disabled={!!visualizza}

            >
                {arrayElement.map((item , key) =>{
                    return(
                        <option 
                            key={key} 
                            value={item.id}
                        >
                            {item.nome}
                        </option>
                    )
                })}
            </select>
            <FormError errors={errors} field={name} />
        </div>
    )
}